import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './Pages/AdminLogin';
import AdminDashboard from './Pages/AdminDashboard';
import StudentRegistration from './Pages/CourseReg';
import AddUser from './Pages/AddUser';
import { auth } from './firebase/firebase';
import UpdateApplicantForm from './Pages/UpdateApplicantsForm';  // Import the form

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [displayName, setDisplayName] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsLoggedIn(true);
        setDisplayName(user.displayName || '');
      } else {
        setIsLoggedIn(false);
        setDisplayName('');
      }
    });

    return unsubscribe;
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  return (
    <Router>
      <div>
        <Routes>
          <Route
            path="/admin/login"
            element={isLoggedIn ? <Navigate to="/admin/dashboard" /> : <AdminLogin onLogin={handleLogin} />}
          />
          <Route
            path="/admin/dashboard"
            element={isLoggedIn ? <AdminDashboard displayName={displayName} /> : <Navigate to="/admin/login" />}
          />
          <Route path="/student/register" element={<StudentRegistration />} />
          <Route path="/add-user" element={<AddUser />} />
          
          {/* Standalone Route for UpdateApplicantForm */}
          <Route path="/update-applicant" element={<UpdateApplicantForm />} />

          <Route path="*" element={<Navigate to="/admin/login" />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
